import { bool, number, string, func, shape, arrayOf } from "prop-types";
import { isMobile } from "react-device-detect";
import {
  Stepper as StepperBase,
  Step,
  StepLabel,
  Fab,
  IconButton,
} from "@material-ui/core";
import { Check } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import useStyle from "./Stepper.style";
import classnames from "classnames";

export const Stepper = ({
  activeStep,
  steps,
  setActiveStep,
  mini,
  className,
}) => {
  const { t } = useTranslation();
  const classes = useStyle(isMobile);

  const changeStep = (i) => setActiveStep(i);

  return (
    <StepperBase
      activeStep={activeStep}
      className={classnames(classes.root, mini && classes.isMini, className)}
      alternativeLabel
    >
      {steps.map((s, i) => (
        <Step key={s.label}>
          <StepLabel
            aria-selected={i === activeStep}
            className={`${classes.stepLabel} ${
              i === activeStep ? classes.currentStep : ""
            }`}
            StepIconComponent={() =>
              s.completed && !s.locked ? (
                <Fab
                  className={
                    mini ? classes.previousStepMini : classes.previousStep
                  }
                  color="primary"
                  onClick={() => changeStep(i)}
                  aria-label={`completed step number ${i + 1}`}
                >
                  <Check />
                </Fab>
              ) : (
                <IconButton
                  className={`${classes.stepIcon} ${
                    mini ? classes.stepIconMini : ""
                  } ${i === activeStep ? classes.stepIconActive : ""}`}
                  onClick={() => changeStep(i)}
                  aria-label={`step number ${i + 1}`}
                  disabled={s.locked}
                >
                  {i + 1}
                </IconButton>
              )
            }
          >
            {t(s.label)}
          </StepLabel>
        </Step>
      ))}
    </StepperBase>
  );
};

Stepper.propTypes = {
  activeStep: number.isRequired,
  steps: arrayOf(
    shape({
      label: string.isRequired,
      completed: bool.isRequired,
      locked: bool,
    })
  ).isRequired,
  setActiveStep: func.isRequired,
  mini: bool,
  className: string,
};
